import { PropsWithChildren } from "react";

export const InvoicePageA4: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <div
      style={{
        width: 1015,
        height: 1478,
        display: "flex",
        flexDirection: "column",
        color: "#303030",
        fontFamily: "monospace",
        letterSpacing: 0.01
      }}
    >
      {children}
    </div>
  );
};
